import { root_props } from '../main';

export function is_part_time_mode() {
    return root_props.part_time_mode
}

export function get_image_cdn_url(url: any) {
    if (url && !url.startsWith('funcolor') && !url.startsWith('cover')) {
        return root_props.cf_cdn_url  + "/" + url
    } else {
        return root_props.cdn_url + "/" + url
    }
}